import { getExternalUrl } from 'utils/utils';
import { ReactNode } from 'react';

// TODO: check security of external link because headers [Now it seems OK]
export const LinkExternal = ({
	href,
	children,
}: {
	href: string;
	children: ReactNode | string;
}) => {
	const url = getExternalUrl(href);

	return (
		<a href={url} target={'_blank'} rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
			{children}
		</a>
	);
};
